import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useState } from "react";
import StudentPage from "./pages/StudentPage";
import AdminPage from "./pages/AdminPage";
import ManagePage from "./pages/ManagePage";
import LoginPage from "./pages/LoginPage";
import { LoadingProvider } from "./contexts/LoadingContext";

function ProtectedRoute({ children, role }) {
  const userRole = localStorage.getItem("role");
  return userRole === role ? children : <Navigate to="/login" />;
}

function App() {
  const [requests, setRequests] = useState([]);

  return (
    <LoadingProvider>


      <BrowserRouter>
        <Routes>
          {/* Trang chủ */}
          <Route
            path="/"
            element={<StudentPage requests={requests} setRequests={setRequests} />}
          />

          {/* Login */}
          <Route path="/login" element={<LoginPage />} />

          {/* Sĩ quan */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute role="admin">
                <AdminPage requests={requests} setRequests={setRequests} />
              </ProtectedRoute>
            }
          />

          {/* Quản lý */}
          <Route
            path="/manage"
            element={
              <ProtectedRoute role="manage">
                <ManagePage requests={requests} />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </LoadingProvider>
  );
}

export default App;
